import { apiget, apipost } from "../../api";

export const types = {
  GET_DISK_USAGE: "GET_DISK_USAGE",
  GET_MEM_USAGE: "GET_MEM_USAGE",
  GET_UPTIME: "GET_UPTIME",
  GET_VARIOUS_META: "GET_VARIOUS_META",
  GET_AGENCE: "GET_AGENCE",
  SET_AGENCE: "SET_AGENCE",
  GET_SEQUENCE: "GET_SEQUENCE",
  SET_SEQUENCE: "SET_SEQUENCE",
  GET_HOME_V2: "GET_HOME_V2",
  SET_HOME_V2: "SET_HOME_V2",
  GET_PROJECT_SELECTION: "GET_PROJECT_SELECTION",
  SET_PROJECT_SELECTION: "SET_PROJECT_SELECTION",
  GET_AXES: "GET_AXES",
  SET_AXES: "SET_AXES",
  GET_META_PROJECTS: "GET_META_PROJECTS",
  SET_META_PROJECTS: "SET_META_PROJECTS",
  GET_DETAILED_AGENCE: "GET_DETAILED_AGENCE",
  SET_DETAILED_AGENCE: "SET_DETAILED_AGENCE",
  GET_WEBHOOK_PARAMS: "GET_WEBHOOK_PARAMS",
  SET_WEBHOOK_PARAMS: "SET_WEBHOOK_PARAMS",
  GET_AXES_DETAILS: "GET_AXES_DETAILS",
  SET_AXES_DETAILS: "SET_AXES_DETAILS",
  GET_MENUS: "GET_MENUS",
  SET_MENUS: "SET_MENUS",
  GET_AXE_TEXTS: "GET_AXE_TEXTS",
  SET_AXE_TEXTS: "SET_AXE_TEXTS"
};

export const actions = {
  [types.GET_DISK_USAGE]: token => async () =>
    await apiget(`/meta/disk_usage`, {}, token),
  [types.GET_MEM_USAGE]: token => async () =>
    await apiget(`/meta/mem_usage`, {}, token),
  [types.GET_UPTIME]: token => async () =>
    await apiget(`/meta/uptime`, {}, token),
  [types.GET_VARIOUS_META]: token => async () =>
    await apiget(`/meta/various_meta`, {}, token),
  [types.GET_AGENCE]: token => async () =>
    await apiget("/meta/agence", {}, token),
  [types.SET_AGENCE]: token => async (_, data) =>
    await apipost("/meta/agence", data, token),
  [types.GET_SEQUENCE]: token => async () =>
    await apiget("/meta/sequence", {}, token),
  [types.SET_SEQUENCE]: token => async (_, data) =>
    await apipost("/meta/sequence", data, token),
  [types.GET_HOME_V2]: token => async () =>
    await apiget("/meta/home_v2", {}, token),
  [types.SET_HOME_V2]: token => async (_, data) =>
    await apipost("/meta/home_v2", data, token),
  [types.GET_PROJECT_SELECTION]: token => async () =>
    await apiget("/meta/project_selection", {}, token),
  [types.SET_PROJECT_SELECTION]: token => async (_, data) =>
    await apipost("/meta/project_selection", data, token),
  [types.GET_AXES]: token => async () => await apiget("/meta/axes", {}, token),
  [types.SET_AXES]: token => async (_, data) =>
    await apipost("/meta/axes", data, token),
  [types.GET_META_PROJECTS]: token => async () =>
    await apiget("/meta/projects", {}, token),
  [types.SET_META_PROJECTS]: token => async (_, data) =>
    await apipost("/meta/projects", data, token),
  [types.GET_DETAILED_AGENCE]: token => async () =>
    await apiget("/meta/detailed_agence", {}, token),
  [types.SET_DETAILED_AGENCE]: token => async (_, data) =>
    await apipost("/meta/detailed_agence", data, token),
  [types.GET_WEBHOOK_PARAMS]: token => async () =>
    await apiget("/meta/webhook_params", {}, token),
  [types.SET_WEBHOOK_PARAMS]: token => async (_, data) =>
    await apipost("/meta/webhook_params", data, token),
  [types.GET_AXES_DETAILS]: token => async () =>
    await apiget("/meta/axes_details", {}, token),
  [types.SET_AXES_DETAILS]: token => async (_, data) =>
    await apipost("/meta/axes_details", data, token),
  [types.GET_MENUS]: token => async () => await apiget("/meta/menu", {}, token),
  [types.SET_MENUS]: token => async (_, data) =>
    await apipost("/meta/menu", data, token),
  [types.GET_AXE_TEXTS]: token => async () =>
    await apiget("/meta/axe_text", {}, token),
  [types.SET_AXE_TEXTS]: token => async (_, data) =>
    await apipost("/meta/axe_text", data, token)
};
